import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { LogmanYieldMaxService } from '../../logman-yieldmax.service';
import { LogmanYieldMax } from '../../logman-yieldmax';
import { AlertService, AuthenticationService, DataCacheService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { DatePipe } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { LogmanYieldMaxComponent } from '../logman-yieldmax/logman-yieldmax.component';


@Component({
    selector: 'app-logman-yieldmax-list',
    templateUrl: './logman-yieldmax-list.component.html',
    styleUrls: ['./logman-yieldmax-list.component.css'],
    providers: [DialogService],
    standalone: false
})
export class LogmanYieldMaxListComponent implements OnInit {
	datasource: LogmanYieldMax[];
	logman: LogmanYieldMax;
	logmans: LogmanYieldMax[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];
	interval;
	referenceId: any;
	severity: any;
	filterDay: any;
	propertyId: any;

	severities = [
		{ name: 'ERROR', value: 'ERROR' },
		{ name: 'INFO', value: 'INFO' },
		{ name: 'WARN', value: 'WARN' },
		{ name: 'SUCCESS', value: 'SUCCESS' },
	];



	constructor(
		private authenticationService: AuthenticationService,
		private logmanYieldMaxService: LogmanYieldMaxService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private messageService: MessageService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		public dialogService: DialogService
	) { }


	ngOnInit() {
		// Positional path params (legacy links): /logmans-yieldmax/:referenceId/:severity/:day
		this.activatedRoute.params.subscribe(params =>
			{
				this.referenceId = params.referenceId;
				this.severity = params.severity;
				this.filterDay = params.day;
			});
		// Query params (newer links) override path params and add propertyId support, e.g.
		// /logmans-yieldmax?referenceId=SYNC_RATES&severity=SUCCESS&propertyId=4500&day=2026-06-02
		this.activatedRoute.queryParamMap.subscribe(qp =>
			{
				if (qp.get('referenceId') != null) { this.referenceId = qp.get('referenceId'); }
				if (qp.get('severity') != null)    { this.severity = qp.get('severity'); }
				if (qp.get('day') != null)         { this.filterDay = qp.get('day'); }
				this.propertyId = qp.get('propertyId');
			});
		 this.loadLazy(this.lazyLoadEvent);
    this.interval = setInterval(() => { 
        this.loadLazy(this.lazyLoadEvent); 
    }, 300000);
	 }



	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);



			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.referenceId != null)
			{
				event.filters['referenceId'] = {"value":this.referenceId,"matchMode":"in"};
			}
			if(this.severity != null)
			{
				event.filters['severity'] = {"value":this.severity,"matchMode":"in"};
			}
			if(this.propertyId != null)
			{
				event.filters['propertyId'] = {"value":this.propertyId,"matchMode":"in"};
			}
			if(this.filterDay != null)
			{
				let filterDay = this.addLocalTimeToDateTime(new Date(this.filterDay));
				let date = this.datePipe.transform(filterDay, 'yyyy-MM-ddThh:mm');
				// if(this.filterDay == 'today')
				// {
				// 	let date = this.datePipe.transform(today, 'yyyy-MM-ddThh:mm');
				// 	event.filters['createDate'] = {"value":date,"matchMode":"in"};
				// }
				// else if(this.filterDay == 'yesterday')
				// {
				// 	// Set day minus 1 day
				// 	today.setDate(today.getDate() - 1);
				// 	let date = this.datePipe.transform(today, 'yyyy-MM-ddThh:mm');
				// 	event.filters['createDate'] = {"value":date,"matchMode":"in"};
				// }
				event.filters['createDate'] = {"value":date,"matchMode":"in"};
			}
			const pageNumber = Math.round(event.first / event.rows);
			this.logmanYieldMaxService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					res => {
						this.datasource = res.data.logmans;
						this.recordTotal = res.page.recordTotal;
						this.logmans = res.data.logmans;
						console.log(JSON.stringify(res.page))
					},
					err => {
						console.log('logmans list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.logmans = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {

		const ref = this.dialogService.open(LogmanYieldMaxComponent, {
			data: {
				logman: event.data
			},
			header: 'Logman',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((logman: LogmanYieldMax) => {
			if (logman) {
				if (logman.action === 'UPDATED') {
					var foundIndex = this.logmans.findIndex(x => x.logmanId == logman.logmanId);
					this.logmans[foundIndex] = logman;
				}

				if (logman.action === 'DELETED') {
					var foundIndex = this.logmans.findIndex(x => x.logmanId == logman.logmanId);
					this.logmans.splice(foundIndex, 1);
					this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Logman ' + logman.logmanId + ' Deleted.', sticky: false });
				}
			}
		});
	}



	onNewLogmanButtonClick() {
		const ref = this.dialogService.open(LogmanYieldMaxComponent, {
			header: 'Logman',
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((logman: LogmanYieldMax) => {
			if (logman) {

				if (logman.action === 'ADDED') {
					this.logmans.unshift(logman);
				}
			}
		});
	}
	get Severities() {
		return this.severities;
	}

	getSeverityName(logman: any) {
		const severity = this.severities.find(e => e.value === logman.severity);
		return severity.name;
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
